import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, DataTable, PrimaryButton } from "@/components/DataViews";
import StatusBadge from "@/components/StatusBadge";
import ExportButton from "@/components/ExportButton";
import { Plus, RefreshCw } from "lucide-react";
import { fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function IndentsList() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  const load = () => {
    setLoading(true);
    api.get("/indents").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const filtered = status === "all" ? items : items.filter((i) => i.status === status);

  return (
    <div data-testid="indents-page">
      <PageHeader
        title="Indent Requirement & Requisitions"
        subtitle="Raise a requirement, freeze it, then convert directly into a Purchase Order."
        actions={
          <>
            <Button variant="outline" onClick={load} data-testid="refresh-btn"><RefreshCw size={14} className="mr-2" />Refresh</Button>
            <ExportButton entity="indents" filename="indent-requirements.xlsx" />
            <PrimaryButton onClick={() => nav("/indents/new")} data-testid="new-indent-btn"><Plus size={14} className="mr-2" />New Requirement</PrimaryButton>
          </>
        }
      />

      <Tabs value={status} onValueChange={setStatus} className="mb-4">
        <TabsList data-testid="status-tabs">
          <TabsTrigger value="all" data-testid="tab-all">All ({items.length})</TabsTrigger>
          <TabsTrigger value="Draft" data-testid="tab-draft">Draft ({items.filter(i => i.status === "Draft").length})</TabsTrigger>
          <TabsTrigger value="Frozen" data-testid="tab-frozen">Frozen ({items.filter(i => i.status === "Frozen").length})</TabsTrigger>
          <TabsTrigger value="Approved" data-testid="tab-approved">Converted to PO ({items.filter(i => i.status === "Approved").length})</TabsTrigger>
          <TabsTrigger value="Rejected" data-testid="tab-rejected">Rejected ({items.filter(i => i.status === "Rejected").length})</TabsTrigger>
        </TabsList>
      </Tabs>

      <DataTable
        testid="indents-table"
        columns={[
          { key: "indent_no", label: "Requirement No.", render: (r) => <span className="font-mono text-xs font-semibold">{r.indent_no}</span> },
          { key: "date", label: "Date", render: (r) => fmtDate(r.date) },
          { key: "project_name", label: "Project" },
          { key: "site_name", label: "Site" },
          { key: "priority", label: "Priority", render: (r) => <span className={`text-xs font-semibold ${r.priority === "Emergency" ? "text-red-600" : r.priority === "Urgent" ? "text-amber-600" : "text-muted-foreground"}`}>{r.priority}</span> },
          { key: "items", label: "Items", render: (r) => r.items?.length || 0 },
          { key: "created_by_name", label: "Created By" },
          { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
        ]}
        data={filtered}
        empty={loading ? "Loading…" : "No requirements yet. Click 'New Requirement' to raise one."}
        onRow={(r) => nav(`/indents/${r.id}`)}
      />
    </div>
  );
}
